var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-anchor",style:(_vm.styles),attrs:{"id":_vm.$attrs._id}},[_c('div',{staticClass:"tag-line",style:(_vm.lineStyle)}),(_vm.tailPosition !== 'none')?_c('div',{staticClass:"tag-dot"}):_vm._e(),_c('div',{ref:"el",staticClass:"tag-action",class:[
      ("tag-action--" + _vm.type)
    ],style:(_vm.labelStyle)},[_c('fa',{attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }